// extracted by mini-css-extract-plugin
export var errorIcon = "_ks-1";
export var nameLogo = "_ks-0";